import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { max, min } from '../../helpers/numbers';
export var calculateItemWidth = function calculateItemWidth(_ref) {
  var containerWidth = _ref.containerWidth,
      numberOfCards = _ref.numberOfCards;
  return containerWidth / numberOfCards;
};
export var calculateLastPossibleTranslateX = function calculateLastPossibleTranslateX(_ref2) {
  var activeItemIndex = _ref2.activeItemIndex,
      containerWidth = _ref2.containerWidth,
      numberOfChildren = _ref2.numberOfChildren,
      numberOfCards = _ref2.numberOfCards;
  var itemWidth = calculateItemWidth({
    containerWidth: containerWidth,
    numberOfCards: numberOfCards
  });
  return Math.round(itemWidth * (numberOfChildren - numberOfCards));
};
export var calculateActiveItemTranslateX = function calculateActiveItemTranslateX(_ref3) {
  var infinite = _ref3.infinite,
      activeItemIndex = _ref3.activeItemIndex,
      containerWidth = _ref3.containerWidth,
      numberOfChildren = _ref3.numberOfChildren,
      numberOfCards = _ref3.numberOfCards;

  if (infinite) {
    var _itemWidth = calculateItemWidth({
      containerWidth: containerWidth,
      numberOfCards: numberOfCards
    });

    return Math.round(_itemWidth * activeItemIndex);
  }

  if (numberOfChildren <= numberOfCards) {
    return 0;
  }

  if (activeItemIndex <= 0) {
    return 0;
  } // Last items to show


  if (activeItemIndex > numberOfChildren - Math.floor(numberOfCards) - 1) {
    return calculateLastPossibleTranslateX({
      activeItemIndex: activeItemIndex,
      containerWidth: containerWidth,
      numberOfChildren: numberOfChildren,
      numberOfCards: numberOfCards
    });
  }

  var itemWidth = calculateItemWidth({
    containerWidth: containerWidth,
    numberOfCards: numberOfCards
  });
  return Math.round(itemWidth * activeItemIndex);
};
export var shouldShowRightChevron = function shouldShowRightChevron(_ref4) {
  var infinite = _ref4.infinite,
      activeItemIndex = _ref4.activeItemIndex,
      numberOfCards = _ref4.numberOfCards,
      numberOfChildren = _ref4.numberOfChildren,
      slidesToScroll = _ref4.slidesToScroll;

  if (infinite) {
    return true;
  }

  if (numberOfChildren <= numberOfCards) {
    return false;
  }

  return calculateNextIndex({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfCards: numberOfCards,
    numberOfChildren: numberOfChildren,
    slidesToScroll: slidesToScroll
  }) > activeItemIndex;
};
export var shouldShowLeftChevron = function shouldShowLeftChevron(_ref5) {
  var infinite = _ref5.infinite,
      activeItemIndex = _ref5.activeItemIndex,
      numberOfCards = _ref5.numberOfCards,
      numberOfChildren = _ref5.numberOfChildren,
      slidesToScroll = _ref5.slidesToScroll;

  if (infinite) {
    return true;
  }

  if (numberOfChildren <= numberOfCards) {
    return false;
  }

  return calculatePreviousIndex({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfCards: numberOfCards,
    numberOfChildren: numberOfChildren,
    slidesToScroll: slidesToScroll
  }) < activeItemIndex;
};
export var calculateNextIndex = function calculateNextIndex(_ref6) {
  var activeItemIndex = _ref6.activeItemIndex,
      numberOfChildren = _ref6.numberOfChildren,
      numberOfCards = _ref6.numberOfCards,
      slidesToScroll = _ref6.slidesToScroll,
      infinite = _ref6.infinite;
  return infinite ? activeItemIndex + slidesToScroll : min([activeItemIndex + slidesToScroll, numberOfChildren - numberOfCards]);
};
export var calculatePreviousIndex = function calculatePreviousIndex(_ref7) {
  var activeItemIndex = _ref7.activeItemIndex,
      numberOfCards = _ref7.numberOfCards,
      numberOfChildren = _ref7.numberOfChildren,
      slidesToScroll = _ref7.slidesToScroll,
      infinite = _ref7.infinite;
  return infinite ? activeItemIndex - slidesToScroll : min([max([activeItemIndex - slidesToScroll, 0]), numberOfChildren - numberOfCards - 1]);
};
export var getNextIndex = function getNextIndex(itemIndex, itemWidths, containerWidth) {
  var _itemWidths$reduce$in;

  var newIndex = (_itemWidths$reduce$in = itemWidths.reduce(function (acc, width, index) {
    if (index < itemIndex || acc.index !== null) {
      return acc;
    }

    if (acc.width + width > containerWidth) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        index: index
      });
    }

    return _objectSpread(_objectSpread({}, acc), {}, {
      width: acc.width + width
    });
  }, {
    width: 0,
    index: null
  }).index) != null ? _itemWidths$reduce$in : itemWidths.length - 1;
  return newIndex > itemIndex ? newIndex : itemIndex + 1;
};
export var getPreviousIndex = function getPreviousIndex(itemIndex, itemWidths, containerWidth) {
  var _itemWidths$reduceRig;

  var newIndex = (_itemWidths$reduceRig = itemWidths.reduceRight(function (acc, width, index) {
    if (index >= itemIndex || acc.index !== null) {
      return acc;
    }

    if (acc.width + width > containerWidth) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        index: index + 1
      });
    }

    return _objectSpread(_objectSpread({}, acc), {}, {
      width: acc.width + width
    });
  }, {
    width: 0,
    index: null
  }).index) != null ? _itemWidths$reduceRig : 0;
  return newIndex < itemIndex ? newIndex : itemIndex - 1;
};
export var getItemIndex = function getItemIndex(index, count) {
  var reducedIndex = index % count;
  return reducedIndex >= 0 ? reducedIndex : (reducedIndex + count) % count;
};